import { Form } from "react-bootstrap";
import { formatNumberOnly, format_mask } from "./utils";
import React, { useMemo, useState } from "react";
import "./style.scss";

export default function({
  title,
  name,
  onChange,
  value,
  min,
  ...props
}){

  const [Value, SetValue] = useState(value?value:"");

  let {cleanable, onClear, ...props_aux} = props;

  const className = useMemo(()=>{
    let __class = "";
    if(min !== null || min !== undefined){
      if(parseFloat(min) > parseFloat(value)){
        __class = "error-limit"
      }
    }
    return __class;
  },[min, value]);

  return (
    <Form.Control
      className={className}
      onChange={(event)=>{
        let target = event.target;
        let aux_value = target.value;
        let start = target.selectionStart;
        
        if(formatNumberOnly(aux_value) !== "" && !parseInt(formatNumberOnly(aux_value)) && parseInt(formatNumberOnly(aux_value)) !== 0){
          return;
        }
        let {value, index, start_index} = format_mask(props.mask, aux_value, Value);
        if(aux_value[0])
        setTimeout(()=>{
          if(start)
          target.setSelectionRange(Math.min.apply(null, [index,start+start_index]), Math.min.apply(null, [index,start+start_index]));
        },1);
        if(onChange && formatNumberOnly(value) !== Value){
          onChange(formatNumberOnly(value))
        }
        SetValue(formatNumberOnly(value));
      }} 
      name={name}
      value={(()=>{
        let {value:v} = format_mask(props.mask, value||"", Value)
        return v;
      })()}
      {...props_aux}
    />
  );
}